import { rootApi } from '../api/rootApi';
import { getApi } from '../api/getApi';
import { postApi } from '../api/postApi';
import { putApi } from '../api/putApi';
import { deleteApi } from '../api/deleteApi';

export const bookingService = {
    getAllBookings: async () => {
        return await getApi(rootApi.bookingTour);
    },
    getMyBookings: async (email) => {
        return await getApi(`${rootApi.bookingTour}/${email}`);
    },
    addBooking: async (data) => {
        return await postApi(rootApi.bookingTour, data);
    },
    updateBookingStatus: async (id) => {
        return await putApi(`${rootApi.bookingTour}/${id}`, {});
    },
    deleteBooking: async (id) => {
        return await deleteApi(`${rootApi.bookingTour}/${id}`);
    }
};
